import {
  BarSeriesSettings,
  BasicLinearSettings,
  BasicLineSeriesSettings,
  ChartStyleSettings,
  DoughnutSettings,
  LinearSeriesSettings,
  LineType,
  ReportType,
  SeriesSettings,
  SerieType,
} from "../../../../api/biClient.types.ts";

export function getLinearSettings(settings: ChartStyleSettings): BasicLinearSettings | undefined {
  switch (settings.type) {
    case ReportType.BarChart:
    case ReportType.LineChart:
    case ReportType.AreaChart:
      return settings;
    default:
      return undefined;
  }
}

export function getDoughnutSettings(settings: ChartStyleSettings): DoughnutSettings | undefined {
  switch (settings.type) {
    case ReportType.DoughnutChart:
      return settings;
    default:
      return undefined;
  }
}

export function getDefaultSerieType(reportType: ReportType): SerieType | undefined {
  switch (reportType) {
    case ReportType.BarChart:
      return "Bar";
    case ReportType.LineChart:
      return "Line";
    case ReportType.AreaChart:
      return "Area";
    default:
      return undefined;
  }
}
export function getDefaultLineType(): LineType {
  return "Line";
}

export function isLinearSettings(settings: ChartStyleSettings): boolean {
  return !!getLinearSettings(settings);
}

export function isBarSerie(settings: ChartStyleSettings, serie: SeriesSettings): boolean {
  if (!isLinearSettings(settings)) return false;
  const linearSerie = serie as LinearSeriesSettings;
  return linearSerie?.serieType === "Bar";
}

export function toBarSerie(serie: SeriesSettings): BarSeriesSettings | undefined {
  const linearSerie = serie as LinearSeriesSettings;
  if (linearSerie?.serieType === "Bar") return linearSerie as BarSeriesSettings;
  return undefined;
}

export function toBasicLineSerie(serie: SeriesSettings | undefined): BasicLineSeriesSettings | undefined {
  const linearSerie = serie as BasicLineSeriesSettings;
  if (linearSerie?.serieType === "Line" || linearSerie?.serieType === "Area") {
    return linearSerie;
  }
  return undefined;
}

export function isLineBasedSerie(settings: ChartStyleSettings, serie: SeriesSettings): boolean {
  if (!isLinearSettings(settings)) return false;
  const linearSerie = serie as BasicLineSeriesSettings;
  return linearSerie?.serieType === "Line" || linearSerie?.serieType === "Area";
}
export function getDxSerieType(settingsArea: ChartStyleSettings, serie: SeriesSettings | undefined) {
  const serieType = getSerieType(settingsArea, serie);
  switch (serieType) {
    case "Bar":
      return "bar";
    case "Line":
    case "Area":
      return getDxLineType(serie);
    default:
      return "bar";
  }
}
export function getDxLineType(serie: SeriesSettings | undefined) {
  const lineSerie = toBasicLineSerie(serie);

  switch (lineSerie?.lineType) {
    case "Line":
      return lineSerie?.serieType === "Line" ? "line" : "area";
    case "Spline":
      return lineSerie?.serieType === "Line" ? "spline" : "splinearea";
    case "Stepline":
      return lineSerie?.serieType === "Line" ? "stepline" : "steparea";
    default: {
      return lineSerie?.serieType === "Line" ? "line" : "area";
    }
  }
}

export function getSerieType(settings: ChartStyleSettings, serie: SeriesSettings | undefined): SerieType {
  const linearSerie = serie as LinearSeriesSettings;
  return linearSerie?.serieType || getDefaultSerieType(settings.type);
}
